import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

import { env } from '../environments/environment';
import { ExchangeRatesDto } from './api/exchangeRatesDto';
import { ConfigDto } from './api/configDto';
import { BalancesDto } from './api/balancesDto';

const CACHE_SIZE = 1;

@Injectable({
	providedIn: 'root'
})
export class GlobalService {
	balances$: Subject<BalancesDto>;
	private exchangeRates$: Observable<ExchangeRatesDto>;
	private configCache$: Observable<ConfigDto>;

	constructor(private http: HttpClient) {
		this.balances$ = new Subject<BalancesDto>();
	}

	public getExchangeRates(): Observable<ExchangeRatesDto> {
		return this.http.get<ExchangeRatesDto>(`${env.beURL}/exchange/rates`);
	}

	get exchangeRates() {
		if (!this.exchangeRates$) {
			this.exchangeRates$ = this.getExchangeRates().pipe(shareReplay(CACHE_SIZE));
		}
		return this.exchangeRates$;
	}

	get config() {
		if (!this.configCache$) {
			this.configCache$ = this.requestConfig().pipe(shareReplay(CACHE_SIZE));
		}
		return this.configCache$;
	}

	requestConfig(): Observable<ConfigDto> {
		return this.http.get<ConfigDto>(`${env.beURL}/cfg`);
	}

	getBalances(): Observable<BalancesDto> {
		return this.http.get<BalancesDto>(`${env.beURL}/balances`).pipe(tap(response => this.balances$.next(response)));
	}
}